import React from 'react';
import { FormattedMessage } from 'react-intl';

import AbstractTable from '../../../common/AbstractTable';
import ListActionItems from '../../../List/ListActionItems';

import { TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table';

class StreamVoD extends AbstractTable {
  static propTypes = {
    ...AbstractTable.propTypes,
    // onChangeFilter: PropTypes.func.isRequired,
    // displayStatus: PropTypes.bool.isRequired
  };

  defaultProps = {
    displayStatus: false
  };

  headerTitle = 'Stream List';
  confirmRemoveMessage = (
    <FormattedMessage
      id="record.remove"
      defaultMessage="Are you sure you want to delete stream video?"
    />
  );

  _renderHeader() {
    const { tableHeaderStyle, fixedHeaderStyle } = this.getStyles();
    return (
      <TableRow>
        <TableHeaderColumn style={tableHeaderStyle}>Name</TableHeaderColumn>
        <TableHeaderColumn style={fixedHeaderStyle}>Actions</TableHeaderColumn>
      </TableRow>
    );
  }

  onDragStart(e){
    e.currentTarget.classList.add('dragActive')
    e.dataTransfer.setData('Text', e.currentTarget.dataset.id)
    e.currentTarget.style.backgroundColor = '#ecf0ff'
    e.dataTransfer.effectAllowed = 'move'
  }
  onDragEnd(e){
    e.currentTarget.style.opacity = 1
    const current = document.querySelector('.dragActive')
    current.style.backgroundColor = 'white'
    document.querySelector('.dragActive').classList.remove('dragActive')
    e.preventDefault()
    e.stopPropagation()
  }
  onDragOver(e){
    const current = document.querySelector('.dragActive')
    if(current.dataset.id  === e.currentTarget.dataset.id) return
    e.dataTransfer.dropEffect = 'move';
    e.currentTarget.style.borderTop = '51px solid rgb(224, 224, 224)';
    e.currentTarget.style.borderBottom = '1px solid rgb(224, 224, 224)'
    e.currentTarget.style.transitionDuration = '0.1s';
    e.preventDefault()
    e.stopPropagation()

  }
  onDragLeave(e){
    e.dataTransfer.dropEffect = 'move';
    e.currentTarget.style.opacity = 1
    e.currentTarget.style.borderTop =  '1px solid rgb(224, 224, 224)'
    e.currentTarget.style.borderBottom =  '1px solid rgb(224, 224, 224)'
    e.preventDefault()
    e.stopPropagation()
  }
  onDrop(e){

    e.currentTarget.style.borderTop =  '1px solid rgb(224, 224, 224)'
    e.currentTarget.style.borderBottom =  '1px solid rgb(224, 224, 224)'
    
    e.preventDefault()
    e.stopPropagation()
    const current = document.querySelector('.dragActive')
    // this.props.publish(this.props.model, data)
    current.style.backgroundColor = 'white'
    const current_item = this.props.items[current.dataset.id]
    const drop_item = this.props.items[e.currentTarget.dataset.id]
    const prev_item = this.props.items[this.props.list[this.props.list.indexOf(e.currentTarget.dataset.id) - 1]] || {}
    const prev__item_number = prev_item.order_number || (drop_item.order_number + 200)

    const order_number = parseInt(drop_item.order_number + (prev__item_number - drop_item.order_number)/2)
    this.props.save(current_item, { ...current_item, order_number })
  }
  _renderContentItem(item, key) {
    let { title, full_name } = item;
    
    const { tableColumnStyle, fixedColumnStyle } = this.getStyles();

    return (
      <TableRow draggable="true" onDragStart={ this.onDragStart.bind(this) } data-order_number={item.order_number} data-id={item.id} onDragEnd={ this.onDragEnd.bind(this) } onDrop={ this.onDrop.bind(this) } onDragOver={this.onDragOver.bind(this)} onDragLeave={this.onDragLeave.bind(this)} key={key} >
        <TableRowColumn style={tableColumnStyle}>
          {title || full_name}
        </TableRowColumn>
        <TableRowColumn style={fixedColumnStyle}>
          <ListActionItems
            edit={this.props.edit}
            remove={this.props.delete}
            record={item}
            confirmMessageLabel={this.confirmRemoveMessage}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default StreamVoD;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamVoD/StreamVoD.jsx